export enum LoaderTarget {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  SYNC_USER = 'SYNC_USER',
  RESET_PASSWORD = 'RESET_PASSWORD'
}

export const GeneralLoaderTargets = [LoaderTarget.LOGIN, LoaderTarget.LOGOUT, LoaderTarget.SYNC_USER];
